{% block swag_migration_wizard_page_create_profile %}
    <div class="swag-migration-wizard swag-migration-wizard-page-create-profile">
        {% block swag_migration_wizard_page_create_profile_content %}
            <div
                v-if="!isLoading"
                class="swag-migration-wizard__content"
            >
                {% block swag_migration_wizard_page_create_profile_selection %}
                    <div class="swag-migration-wizard__form">
                        <mt-banner
                            v-if="profileHint"
                            variant="info"
                        >
                            {{ profileHint }}
                        </mt-banner>

                        <mt-text-field
                            v-model:model-value="selection.connectionName"
                            v-autofocus
                            :label="$tc('swag-migration.wizard.pages.connectionCreate.connectionLabel')"
                            :placeholder="$tc('swag-migration.wizard.pages.connectionCreate.connectionPlaceholder')"
                            validation="required"
                            :help-text="$tc('swag-migration.wizard.pages.connectionCreate.connectionTooltip')"
                            :error="connectionNameError"
                            @update:model-value="onChangeConnectionName"
                        />

                        <sw-single-select
                            v-model:value="selection.profile"
                            :label="$tc('swag-migration.wizard.pages.connectionCreate.profileLabel')"
                            :placeholder="$tc('swag-migration.wizard.pages.connectionCreate.profilePlaceholder')"
                            :popover-classes="['swag-migration-wizard-page-create-profile']"
                            :popover-config="{active: true, resizeWidth: true, style: { zIndex: 1000, marginLeft: '8px' }}"
                            :options="profiles"
                            value-property="name"
                            :search-function="profileSearch"
                            validation="required"
                            @update:value="onSelectProfile"
                        >
                            {% block swag_migration_wizard_page_create_profile_form_profile_field_options %}
                                <template #selection-label-property="{ item: singleSelection, labelProperty, valueProperty, searchTerm, getKey }">
                                    <span v-html="getText(singleSelection)"></span>
                                </template>

                                <template #result-label-property="{ item, index, labelProperty, valueProperty, searchTerm, highlightSearchTerm, getKey }">
                                    <div
                                        v-if="item.name === 'profileLink'"
                                        class="swag-migration-wizard-create-connection__install-profile-link-wrapper"
                                    >
                                        <div>
                                            {{ $tc('swag-migration.wizard.pages.connectionCreate.profileInstall') }}
                                        </div>
                                        <div>
                                            <mt-icon
                                                name="regular-chevron-right-xs"
                                                size="16"
                                            />
                                        </div>
                                    </div>
                                    <span
                                        v-else
                                        v-html="getText(item)"
                                    >
                                    </span>
                                </template>
                            {% endblock %}
                        </sw-single-select>

                        <sw-single-select
                            v-model:value="selection.gateway"
                            class="swag-migration-wizard-page-create-profile__gateway-select"
                            :label="$tc('swag-migration.wizard.pages.connectionCreate.gatewayLabel')"
                            :placeholder="$tc('swag-migration.wizard.pages.connectionCreate.gatewayPlaceholder')"
                            :help-text="$tc('swag-migration.wizard.pages.connectionCreate.gatewayTooltip')"
                            :popover-classes="['swag-migration-wizard-page-create-profile']"
                            :popover-config="{active: true, resizeWidth: true, style: { zIndex: 1000, marginLeft: '8px' }}"
                            :options="gateways"
                            value-property="name"
                            :search-function="gatewaySearch"
                            validation="required"
                            @update:value="onSelectGateway"
                        >
                            {% block swag_migration_wizard_page_create_profile_form_gateway_field_options %}
                                <template #selection-label-property="{ item: singleSelection, labelProperty, valueProperty, searchTerm, getKey }">
                                    {{ $tc(singleSelection.snippet) }}
                                </template>

                                <template #result-label-property="{ item, index, labelProperty, valueProperty, searchTerm, highlightSearchTerm, getKey }">
                                    {{ $tc(item.snippet) }}
                                </template>
                            {% endblock %}
                        </sw-single-select>
                    </div>
                {% endblock %}
            </div>
        {% endblock %}
    </div>
{% endblock %}
